import { deleteFile, updateFile, uploadFile } from '@kizen/api/file';
import UUID from 'utility/UUID';
import AxiosService from './AxiosService';
import { camelToSnakeCaseKeys } from './helpers';
import { FIELD_VALUE_FILE_UPLOAD_SOURCE } from 'hooks/uploadFiles/useUploadFile';

class FileService {
  constructor() {
    if (!FileService.instance) {
      FileService.instance = this;
    }
    return FileService.instance;
  }

  createId = () => UUID.generate();

  getThumbnailUrl = (id) =>
    `${import.meta.env.VITE_API_BASE_PATH}/files/${id}/thumbnail`;

  getStreamUrl = (id) =>
    `${import.meta.env.VITE_API_BASE_PATH}/files/${id}/stream`;

  getImageByCommonKey = async (commonKey) => {
    const {
      data: { results = [] },
    } = await AxiosService.get('/images', {
      params: {
        common_key: commonKey,
      },
    });
    return results.find((q) => q.common_key === commonKey);
  };

  // In order to upload a file, we need to obtain some signing info (basically, permission to talk directly to S3)
  // prior to performing the upload.  Then we tell the API we're done so that it can keep a record of the file.
  upload = async ({
    file,
    id,
    source = FIELD_VALUE_FILE_UPLOAD_SOURCE,
    handleProgress,
    businessId,
    publicFile = false,
  }) => {
    return uploadFile(AxiosService, file, id, businessId, {
      source,
      publicFile,
      handleProgress,
    });
  };

  delete = async ({ id, key }) => {
    await deleteFile(AxiosService, id, key);
  };

  update = async ({ id, params }) => {
    const file = await updateFile(
      AxiosService,
      id,
      camelToSnakeCaseKeys(params)
    );
    return file;
  };

  async getPublicFiles() {
    const { data } = await AxiosService.get(`/files?is_public=true`);
    return data;
  }

  async getPublicFile(id) {
    const { data } = await AxiosService.get(`/files/${id}`);
    return data;
  }
}

const instance = new FileService();
Object.freeze(instance);

export default instance;
